/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// Authority view levels that are used to determine if a user can view certain navigation items
export const VIEW_AUTHORITY = {
  adminAuthority: 'admin-view',
  userAuthority: 'user-view'
};

// Authority modify levels that are used to determine if a user can modify certain navigation items
export const MODIFY_AUTHORITY = {
  adminAuthority: 'admin-modify',
  userAuthority: 'user-modify'
};

// Authority delete levels that are used to determine if a user can delete certain navigation items
export const DELETE_AUTHORITY = {
  adminAuthority: 'admin-delete',
  userAuthority: 'user-delete'
};
